<template>
  <table class="table">
    <thead v-if="!hideHeaders && headers.length">
      <tr>
        <slot v-for="(header, index) of headers" :header="header" :index="index" :name="`header_${header}`">

          <th v-if="header !== 'controls' && (header === 'order_reference' || header === 'from' )" :key="header">
            {{ $t(translationPrefix ? `${translationPrefix}.${header}` : header) }}
          </th>

          <th v-else-if="(header === 'to') || (header === 'destination') || (header === 'license_plate') || (header === 'name') || (header === 'name')" :key="header" class="d-none d-xl-table-cell">
            {{ $t(translationPrefix ? `${translationPrefix}.${header}` : header) }}
          </th>

          <th v-else-if="header === 'controls'" :key="header">
            <i class="fas fa-cog px-2" />
          </th>
        </slot>
      </tr>
    </thead>

    <tbody>
      <tr v-if="!hideNoResults && !loading && !rows.length" class="no-hover no-click">
        <td class="text-center" colspan="999">
          <slot name="noResults">
            {{ $t('no_results') }}
          </slot>
        </td>
      </tr>

      <template v-else>
        <slot v-for="(row, index) of rows" :columns="headers" :index="index" name="row" :row="row">
          <tr @click.native="onRowClick(index)" :columns="headers" :index="index" :is="tableRowComponent" :key="`row_${index}`" :row="row" />
        </slot>
      </template>

      <tr v-if="loading" class="no-hover no-click">
        <td class="text-center" colspan="999">
          <loader :loading="true" />
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import RooshTableRow from '@/components/common/RooshTableRow';

export default {
  name: 'roosh-table',
  props: {
    hideHeaders: Boolean,
    hideNoResults: Boolean,
    loading: Boolean,
    translationPrefix: String,
    headers: {
      type: Array,
      default: () => [],
    },
    rows: {
      type: Array,
      default: () => [],
    },
    tableRowComponent: {
      type: Object,
      default: () => RooshTableRow,
    }
  },
  methods: {
    onRowClick (index) {
      this.$emit('onRowClick', {
        index: index,
        row: this.rows[index],
      });
    },
  },
}
</script>
